<div mdbModal class="modal fade " id="modalSpoolDownload" tabindex="-1" role="dialog" aria-labelledby="scrollDocketLabel">
        <div class="modal-dialog  modal-dialog-centered modal-lg" role="document">
              <div class="modal-content">
  
                    <!--Header-->
                    <div class="modal-header  darken-3 justify-content-center heading ">
                          <h4 class="title text-uppercase font-weight-bold ">
                               Spool File Download
                          </h4>
                          <button type="button" class="close waves-effect waves-light" 
                          data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
                                <span aria-hidden="true">&times;</span>
                          </button>
                    </div>
                    <!--Body-->
                    <div class="modal-body ">
                    <div class="row" data-aos="zoom-in" data-aos-delay="150">
                    <div class="col-xl-12 col-xl-12">
                   

                    <div class="divDataUnavailable" *ngIf="!DataAvaialble">
              <label><b>DATA UNAVAILABLE</b></label>
            </div>
          
            <div [hidden]="!hasData">
              <div class="form-inline md-form form-sm formheight">
                <mdb-icon fas icon="search" aria-hidden="true" class="searchicon iconColor "></mdb-icon>
                <input class="form-control form-control-sm ml-3 w-45" type="text" (keyup)="applyFilter($event)" placeholder="Filter" aria-label="Search" mdbInput>
              </div>

              <div class="d-flex justify-content-center adjust" *ngIf="loading">



<div class="loader " id="loader-4">

      <span></span>
      <span></span>
      <span></span>

</div>
</div>

              <div class="matheightelevate ">
                                                          <mat-table class="pb-2" [dataSource]="spoolDownloadListMatTabDataSource" style="width: 100%;" matSort matSortActive="Created_Date"
                                                            matSortDirection="desc" matSortDisableClear>
                                                            <ng-container matColumnDef="action">
                                                              <mat-header-cell *matHeaderCellDef>No</mat-header-cell>
                                                              <mat-cell *matCellDef="let element; let i = index;">
                                                                {{i+1}}
                                                              </mat-cell>
                                                            </ng-container>
                                                            <ng-container matColumnDef="UserId">
                                                              <mat-header-cell *matHeaderCellDef mat-sort-header>User Name</mat-header-cell>
                                                              <mat-cell *matCellDef="let element"> {{element.UserId}} </mat-cell>
                                                            </ng-container>
                                                            <ng-container matColumnDef="Client">
                                                                  <mat-header-cell *matHeaderCellDef mat-sort-header>Client</mat-header-cell>
                                                                  <mat-cell *matCellDef="let element"> {{element.Client}} </mat-cell>
                                                                </ng-container>
                                                            <ng-container matColumnDef="UploadFileName">
                                                              <mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded File</mat-header-cell>
                                                              <mat-cell *matCellDef="let element"> {{element.UploadFileName}} </mat-cell>
                                                            </ng-container>
                                                            <ng-container matColumnDef="Email_Id">
                                                              <mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded By</mat-header-cell>
                                                              <mat-cell *matCellDef="let element"> {{element.Email_Id}} </mat-cell>
                                                            </ng-container>          
                                                            <ng-container matColumnDef="Created_Date">
                                                              <mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded Date</mat-header-cell>
                                                              <mat-cell *matCellDef="let element"> {{element.Created_Date | date:'MM-dd-yyyy' }}</mat-cell>
                                                            </ng-container>
                                                            <ng-container matColumnDef="UploadFilePath">
                                                              <mat-header-cell *matHeaderCellDef>Download</mat-header-cell>
                                                              <mat-cell *matCellDef="let element">                        
                                                                <i class="fas fa-download fa-lg dowload iconColor " type="button" aria-hidden="true"
                                                                  (click)="downloadFile(element.UploadFilePath,element.UploadFileName)"></i>                    
                                                              </mat-cell>
                                                            </ng-container>
                                                           
                                                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                                          </mat-table>                                           
                                                        
                                        
                                                          <div *ngIf="filedownload.status==='InProgress'">
                                                                <div class="progress mt-2 mb-3" *ngIf="showProgressBar">    
                                                                      <div
                                                                      class="progress-bar progress-bar-striped active"
                                                                      role="progressbar"
                                                                      style="width: {{filedownload.progressPercent}}%"
                                                                      aria-valuemin="0"
                                                                      aria-valuemax="100"
                                                                      >
                                                                     
                                                                      </div>
                                                                </div>
                                                          </div>
                                                          <div *ngIf="showtoastError">                                                                
                                                                <div id="error" class="toast-alert alert-danger hide mt-2" 
                          role="alert" 
                          data-delay="5000" 
                          data-autohide="true" aria-live="assertive" aria-atomic="true" >
                             
                              <div class="toast-body">
                                  <i class="fa fa-check" aria-hidden="true"></i>
                                  {{alertMsg}}
                              </div>
                            </div>
                                                          </div>
                                                          <div *ngIf="showtoastSuccess"> 
                                                          <div id="success" class="toast-alert alert-success hide mt-2 " role="alert" data-delay="5000" data-autohide="true" aria-live="assertive" aria-atomic="true">


<div class="toast-body">
      <i class="fa fa-check" aria-hidden="true"></i>
      {{alertMsg}}
</div>
</div>
</div>
                                                          
                                                          <div class="matcontainer mt-2"> 
                                                          <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10,25]"
                                           showFirstLastButtons class="pb-3" class="mat-paginator-sticky"></mat-paginator>
                                                       </div>
                                                        
                                                  
                                                        </div>


            </div>


              


                    </div>
                   
                    </div>
                    </div>
                    </div>
                                                    
                                                    
                                                    </div>
                                              </div>   
                                   
      